<h1>{{ 'turbo.Common.UploadImageDialog.lblHeadline' | translate:'Upload image' }}</h1>
<mat-dialog-content style="min-width: 400px;">
  <t4-container>
    <input #txtFile type="file" style="visibility: hidden" (change)="upload($event.target.files)" />
    <div class="loader">
      <div class="message">{{ 'T4.Common.UploadImageDialog.msgLoading' | translate : 'Processing' }}</div>
      <mat-progress-bar mode="indeterminate" style="width: 100%; bottom: 0;"></mat-progress-bar>
    </div>
  </t4-container>
</mat-dialog-content>
